import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tellent-assistant-tool-error-pill',
  imports: [IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tool-error-pill.component.html',
  styleUrl: './tool-error-pill.component.less',
})
export class TellentAssistantToolErrorPillComponent {
  public readonly toolName = input.required<string>();
}
